import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// Primary CTA with an orbiting conic-gradient border beam + breathing outer glow.
export const BeamButton = React.forwardRef(
  ({ as = "button", children, className = "", innerClassName = "", ...props }, ref) => {
    const Comp = as === "a" ? motion.a : motion.button;
    const reduce = useReducedMotion();
    return (
      <Comp
        ref={ref}
        whileTap={reduce ? undefined : { scale: 0.96 }}
        className={`group relative inline-flex items-center justify-center p-[2px] rounded-full overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-primary focus-visible:ring-offset-2 focus-visible:ring-offset-main disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
        {...props}
      >
        <span
          aria-hidden="true"
          className="beam-spin absolute left-1/2 top-1/2 aspect-square w-[220%] -translate-x-1/2 -translate-y-1/2 bg-[conic-gradient(from_0deg,transparent_0deg,hsl(var(--theme-primary))_55deg,hsl(var(--theme-secondary))_115deg,transparent_170deg)]"
        />
        <span
          aria-hidden="true"
          className="beam-glow absolute -inset-[2px] -z-10 rounded-full bg-theme-primary/40 blur-md group-hover:bg-theme-primary/60"
        />
        <span
          className={`relative z-10 inline-flex h-full w-full items-center justify-center gap-2 rounded-full bg-surface px-8 py-3.5 font-bold text-text-main transition-colors ${innerClassName}`}
        >
          {children}
        </span>
      </Comp>
    );
  }
);

BeamButton.displayName = "BeamButton";
